import api from './api';

export const getBrands = async (params) => {
  const response = await api.get('/auth/brand', { params });
  return response.data;
};

export const getBrand = async (id) => {
  const response = await api.get(`/auth/brand/${id}`);
  return response.data;
};

export const createBrand = async (data) => {
  const response = await api.post('/auth/brand', data);
  return response.data;
};

export const updateBrand = async (data) => {
  const response = await api.put('/auth/brand', data);
  return response.data;
};

export const deleteBrand = async (id) => {
  const response = await api.delete(`/auth/brand/${id}`);
  return response.data;
};
